import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import CustomerDetails from '@/components/CustomerDetails';
import { formatPhoneNumber } from '@/lib/utils';

interface CustomerProfileModalProps {
  customerId: string | null;
  onClose: () => void;
}

export const CustomerProfileModal: React.FC<CustomerProfileModalProps> = ({
  customerId,
  onClose,
}) => {
  if (!customerId) return null;

  return (
    <Dialog open={!!customerId} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Customer Profile</DialogTitle>
          <DialogDescription>
            View and manage customer details and rewards
          </DialogDescription>
        </DialogHeader>
        <CustomerDetails
          customerId={customerId}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}; 